import {
  AssignedWorkflowPhaseDto,
  AssignedWorkflowScheduledEventDto,
  WorkflowPhaseDto,
  WorkflowPhaseSectionDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const workflowsRequests = {
  getAvailableAssignedWorkflowPhasesByUserId: EndpointDefinition.get<
    AssignedWorkflowPhaseDto[],
    { userId: string }
  >({
    name: 'getAvailableAssignedWorkflowPhasesByUserId',
    route: '/workflows/assigned/phases',
  }),

  getWorkflowPhaseById: EndpointDefinition.get<
    WorkflowPhaseDto,
    { phaseId: number }
  >({
    name: 'getWorkflowPhaseById',
    route: '/workflows/phases/:phaseId',
  }),

  getAssignedWorkflowPhaseById: EndpointDefinition.get<
    AssignedWorkflowPhaseDto,
    { assignedWorkflowPhaseId: number }
  >({
    name: 'getWorkflowPhaseById',
    route: '/workflows/assigned/phases/single/:assignedWorkflowPhaseId',
  }),

  getSectionsByPhaseId: EndpointDefinition.get<
    WorkflowPhaseSectionDto[],
    { phaseId: number; attachContent?: string }
  >({
    name: 'getSectionsByPhaseId',
    route: '/workflows/phases/:phaseId/sections',
  }),

  createWorkflowScheduledEvent: EndpointDefinition.post<
    AssignedWorkflowScheduledEventDto,
    { assignedWorkflowPhaseId: number; scheduledEventId: number },
    null
  >({
    name: 'createWorkflowScheduledEvent',
    route: '/workflows/assigned/scheduled',
  }),

  deleteAssignedWorkflowScheduledEvent: EndpointDefinition.delete<
    AssignedWorkflowScheduledEventDto,
    { assignedWorkflowScheduledEventId: number }
  >({
    name: 'deleteWorkflowScheduledEvent',
    route: '/workflows/assigned/scheduled/:assignedWorkflowScheduledEventId',
  }),

  getNextPhasePreviewSummary: EndpointDefinition.get<
    { summary: string },
    { phaseId: number }
  >({
    name: 'getNextPhasePreviewSummary',
    route: '/workflows/assigned/phases/:phaseId/next-phase-preview-summary',
  }),

  completeAssignedWorkflowPhase: EndpointDefinition.post<
    AssignedWorkflowPhaseDto,
    { id: number },
    null
  >({
    name: 'completeAssignedWorkflowPhase',
    route: '/workflows/assigned/complete/phases',
  }),
};
